export const enum DamageReportStatus {
  Draft = 'Draft',
  Submitted = 'Submitted',
  Viewed = 'Viewed',
  Processing = 'Processing',
  Closed = 'Closed',
}

export const DamageReportStatusId: Record<DamageReportStatus, number> = {
  [DamageReportStatus.Draft]: 1,
  [DamageReportStatus.Submitted]: 2,
  [DamageReportStatus.Viewed]: 3,
  [DamageReportStatus.Processing]: 4,
  [DamageReportStatus.Closed]: 5,
};
